// DrawingSetupDialog.tsx — Global drawing settings (units, scale, border)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';

export default function DrawingSetupDialog() {
  const { project, updateProject } = useShallowStore(s => ({
    project:       s.project,
    updateProject: s.updateProject,
  }));

  const [units,  setUnits]  = useState(project?.settings?.units ?? 'imperial');
  const [border, setBorder] = useState(project?.settings?.titleBlock ?? 'standard');

  if (!project) return null;

  return (
    <DialogBase
      title="Drawing Setup"
      onOk={() => updateProject({ settings: { ...project.settings, units, titleBlock: border } })}
    >
      <div className="dialog-row">
        <label className="dialog-label">Units</label>
        <select
          className="dialog-select"
          value={units}
          onChange={e => setUnits(e.target.value)}
        >
          <option value="imperial">Imperial (inches)</option>
          <option value="metric">Metric (mm)</option>
        </select>
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Title Block</label>
        <select
          className="dialog-select"
          value={border}
          onChange={e => setBorder(e.target.value)}
        >
          <option value="standard">Standard — 24×36"</option>
          <option value="full">Full — 30×42"</option>
          <option value="none">None</option>
        </select>
      </div>
    </DialogBase>
  );
}
